import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { HerracContext } from "../../App";

function DashboardHome() {
    const { user } = useContext(HerracContext);
    const [overview, setOverview] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchOverview = async () => {
            try {
                const res = await axios.get("https://api.herracim.az/api/Dashboard/overview", {
                    withCredentials: true,
                    headers: { "Accept": "application/json" }
                });
                setOverview(res.data);
            } catch (error) {
                if (error.response?.status === 401) {
                    console.warn("İcazəsiz: Giriş edin.");
                    navigate("/giris");
                } else {
                    console.error("Dashboard yüklənmədi:", error);
                }
            }
        };

        fetchOverview();
    }, [navigate]);

    if (!overview) {
        return <div>Yüklənir...</div>;
    }

    return (
        <div className="dashboard-home">
            <div className="dashboard-cards">
                <div className="card"><h3>İstifadəçilər</h3><p>{overview.userCount}</p></div>
                <div className="card"><h3>Ban olunmuşlar</h3><p>{overview.bannedUsers}</p></div>
                <div className="card"><h3>Adminlər</h3><p>{overview.adminCount}</p></div>
                <div className="card"><h3>Yeni istifadəçilər</h3><p>{overview.newUsersToday}</p></div>
                <div className="card"><h3>Hərraclar</h3><p>{overview.auctionCount}</p></div>
                <div className="card"><h3>Yeni hərraclar</h3><p>{overview.newAuctionsToday}</p></div>
                <div className="card"><h3>Aktiv elanlar</h3><p>{overview.activeProducts}</p></div>
                <div className="card"><h3>Toplam elanlar</h3><p>{overview.totalProducts}</p></div>
                <div className="card"><h3>Toplam depozit</h3><p>{overview.totalDepositAmount} AZN</p></div>
            </div>

            <div className="dashboard-tables">
                <div className="table-section">
                    <h2>Son 5 Qeydiyyat</h2>
                    <table>
                        <thead>
                            <tr><th>Ad</th><th>Email</th><th>Tarix</th></tr>
                        </thead>
                        <tbody>
                            {overview.last5Users.map((u, idx) => (
                                <tr key={idx}>
                                    <td>{u.fullName}</td>
                                    <td>{u.email}</td>
                                    <td>{new Date(u.createdAt).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="table-section">
                    <h2>Son 5 Elan</h2>
                    <table>
                        <thead>
                            <tr><th>Ad</th><th>Qiymət</th><th>Tarix</th></tr>
                        </thead>
                        <tbody>
                            {overview.last5Products.map((p, idx) => (
                                <tr key={idx}>
                                    <td>{p.name}</td>
                                    <td>{p.price} AZN</td>
                                    <td>{new Date(p.createdAt).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="table-section">
                    <h2>Son 5 Depozit</h2>
                    <table>
                        <thead>
                            <tr><th>Məbləğ</th><th>Tarix</th></tr>
                        </thead>
                        <tbody>
                            {overview.last5Deposits.map((d, idx) => (
                                <tr key={idx}>
                                    <td>{d.amount} AZN</td>
                                    <td>{new Date(d.createdAt).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default DashboardHome;
